module.exports = __webpack_public_path__ + "static/img/AX.5738c3ed.svg";